import { loadable } from '../../../web/components/Loadable/index';

export const LoadableCohortAdmin = loadable(() => import('./component'), {
  resolveComponent: (mod) => mod.ConnectedCohortAdmin,
});
